@if (profileField$ | async; as profileField) {
    <dt [id]="profileField.FieldDefinition.DottedKey" class="sh-description-list__term" style="{{ nestedPadding$ | async }}">
        <sh-field-label [label]="profileField.DisplayLabel" [labelIcons]="$labelIcons()"></sh-field-label>
    </dt>
    <ng-container
        *ngTemplateOutlet="(value$ | async) !== null ? hasData : emptyData; context: { value: value$ | async, fieldDefinition: profileField.FieldDefinition }"
    >
    </ng-container>
}

<ng-template #hasData let-value="value" let-fieldDefinition="fieldDefinition">
    <ng-container
        *ngTemplateOutlet="canSearchOnClick(fieldDefinition) ? searchableData : nonSearchableData; context: { value: value, fieldDefinition: fieldDefinition }"
    >
    </ng-container>
</ng-template>

<ng-template #searchableData let-value="value" let-fieldDefinition="fieldDefinition">
    <dd [routerLink]="searchRouterLink" [queryParams]="getSearchRouterParams(fieldDefinition, value)" class="sh-link sh-description-list__details">
        <ng-container *ngTemplateOutlet="icon"></ng-container>
    </dd>
</ng-template>

<ng-template #nonSearchableData>
    <dd class="sh-description-list__details">
        <ng-container *ngTemplateOutlet="icon"></ng-container>
    </dd>
</ng-template>

<ng-template #icon>
    <svg sh-icon [name]="icon$ | async" [size]="'small'" aria-hidden="true" class="sh-label-list__item__icon"></svg>
</ng-template>

<ng-template #emptyData>
    <dd class="sh-description-list__details">-</dd>
</ng-template>
